import { render, staticRenderFns } from "./IndividualStore.vue?vue&type=template&id=9c60877c&scoped=true"
import script from "./IndividualStore.vue?vue&type=script&lang=js"
export * from "./IndividualStore.vue?vue&type=script&lang=js"
import style0 from "./IndividualStore.vue?vue&type=style&index=0&id=9c60877c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c60877c",
  null
  
)

export default component.exports